import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { Workspace, Supply } from '../types'

export const useSessionStore = defineStore('session', () => {
  const workspaces = ref<Workspace[]>([])
  const selectedWorkspace = ref<Workspace | null>(null)
  const selectedSupply = ref<Supply | null>(null)

  const workspaceId = computed(() => selectedWorkspace.value?.acc_id ?? null)
  const suppliedAccId = computed(() => selectedSupply.value?.acc_id ?? null)

  function setWorkspaces(data: Workspace[]): void {
    workspaces.value = data
  }

  function selectWorkspace(workspace: Workspace): void {
    selectedWorkspace.value = workspace
    selectedSupply.value = null
  }

  function selectSupply(supply: Supply): void {
    selectedSupply.value = supply
  }

  function resetSelection(): void {
    selectedWorkspace.value = null
    selectedSupply.value = null
  }

  function clear(): void {
    workspaces.value = []
    selectedWorkspace.value = null
    selectedSupply.value = null
  }

  return {
    workspaces,
    selectedWorkspace,
    selectedSupply,
    workspaceId,
    suppliedAccId,
    setWorkspaces,
    selectWorkspace,
    selectSupply,
    resetSelection,
    clear,
  }
})
